import { useEffect, useState } from "react";
import { Distribution } from "../../types/Distribution";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

type Options = {
  communityId?: string;
};

export const useDistribution = ({ communityId }: Options = {}) => {
  const [distribution, setDistribution] = useState<Distribution | null>(null);

  useEffect(() => {
    if (!communityId) {
      setDistribution(null);
      return;
    }

    const docRef = firestore
      .collection(DB_PATH.COMMUNITY)
      .doc(communityId)
      .collection(DB_PATH.DISTRIBUTION)
      .doc("credentials");

    const unsubscribe = docRef.onSnapshot(
      (doc) => {
        if (doc.exists) {
          const data = doc.data() as Distribution;
          setDistribution({ ...data, id: communityId });
        } else {
          setDistribution(null);
        }
      },
      (error) => {
        console.error("Error fetching distribution", error);
        setDistribution(null);
      }
    );

    return () => unsubscribe();
  }, [communityId]);

  return distribution;
};
